import React, { useState, useMemo, useEffect } from "react";
import Table from "../../utils/Table";
import ActionButtons from "../../utils/ActionButtons";
import AddInvoiceModal from "../../components/Modals/AddInvoiceModal";
import { fetchInvoices, updateInvoiceStatus } from "../../services/api";
import { getStatusDot, formatDate } from "../../utils/TableUtils";
import { useLoading } from "../../contexts/LoadingContext";
import { useToast } from "../../contexts/ToastContext";
import paidIcon from "../../assets/images/icons/paid.png";

function Invoices() {
  const [data, setData] = useState([]);
  const [filterInput, setFilterInput] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const { showToast } = useToast();
  const { startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    setLoading(true);
    startLoading(true);
    try {
      const response = await fetchInvoices(pageIndex + 1, 5);
      setData(response?.data);
      setPageCount(response?.pagination?.totalPages);
    } catch (error) {
      console.error("Error fetching communities:", error);
    } finally {
      setLoading(false);
      stopLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageIndex]);

  const columns = useMemo(
    () => [
      {
        Header: "Invoice ID",
        accessor: "invoiceNumber",
      },
      {
        Header: "Billing Community",
        accessor: "communityName",
      },
      {
        Header: "Biling Date",
        accessor: "createdAt",
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: "Amount",
        accessor: "totalAmount",
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => getStatusDot(value),
      },
      {
        Header: "Actions",
        accessor: "actions",
        disableSortBy: true,
        Cell: ({ row }) => (
          <ActionButtons 
            onEdit={handleEdit} 
            rowData={row.original}
            showDelete={false}
            editBtnIcon={paidIcon}
          />
        ),
      },
    ],
    [pageIndex]
  );

  const handleEdit = async (rowData) => {
      try {
        startLoading(true);
        const { invoiceId } = rowData;
        if (!invoiceId) {  // updateInvoiceStatus
          showToast("Invalid ID, please try again.", "error");
          return;
        }
        const response = await updateInvoiceStatus(invoiceId);
        fetchData();
        if (response && response.message) {
          showToast(response.message, "success");
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          showToast(error.response.data.message, "error");
        } else {
          showToast("An error occurred while deleting the community.", "error");
        }
      } finally {
        stopLoading(false);
      }
    };

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };

  const showAddInvoiceModal = ()  => {
    setModalShow(true)
  }

  return (
    <div className="subMain-content">
      <div>
        <h1 className="mt-4">Billing and Invoice</h1>
      </div>

      <Table
        columns={columns}
        data={data}
        filterInput={filterInput}
        setFilterInput={setFilterInput}
        pageCount={pageCount}
        loading={loading}
        handleEdit={handleEdit}
        onPageChange={handlePageChange}
        currentPage={pageIndex}
        showActionButton='true'
        onTrigger={showAddInvoiceModal}
        actionButtonLabel='Issue New Invoice'

      />

      <AddInvoiceModal show={modalShow} onHide={() => setModalShow(false)} />
    </div>
  );
}

export default Invoices;
